import { KikUserZodSchemas } from "@kikocosmeticsorg/uc-api-nest-common-fe/zod";
import { z } from "zod";

// Notify me
export const notifyMeValidationSchemaGuest = z.object({
  EmailAddress: KikUserZodSchemas.email,
  AgreeToTerms: z.boolean().refine((value) => value === true, {
    message: "error.youMustAgreeToTermsAndConditions",
  }),
});

export type NotifyMeValidationFieldsGuest = z.infer<typeof notifyMeValidationSchemaGuest>;
